import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'

import { Grid, MenuItem, TextField, Typography } from '@material-ui/core'
import { Card } from 'components'
import { RadioType } from './components'

const MainForm = ({ editionPermitted, isDPO, editionMode }) => {
  const { errors, control, watch } = useFormContext()

  const kind = watch('documentKind')

  return (
    <Card title="Preencha os dados do Grupo Advisor">
      <RadioType disabled={editionMode} />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                fullWidth
                error={!!errors.name}
                helperText={errors?.name?.message}
                label="Nome do Grupo Advisor"
                disabled={!editionPermitted}
                inputProps={{ maxLength: 60 }}
              />
            }
            control={control}
            name="name"
            mode="onBlur"
          />
        </Grid>
        {isDPO && (
          <>
            <Grid item xs={12} md={6}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    error={!!errors.documentKind}
                    helperText={errors?.documentKind?.message}
                    label="Tipo de Documento"
                    disabled={editionMode}
                    inputProps={{ maxLength: 60 }}
                    select
                  >
                    <MenuItem value="cpf">
                      <Typography>CPF</Typography>
                    </MenuItem>
                    <MenuItem value="cnpj">
                      <Typography>CNPJ</Typography>
                    </MenuItem>
                  </TextField>
                }
                control={control}
                name="documentKind"
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    error={!!errors?.[kind]}
                    helperText={errors?.[kind]?.message}
                    label={kind?.toUpperCase() || 'Documento'}
                    disabled={!kind || editionMode}
                    inputProps={{ maxLength: 60 }}
                  />
                }
                control={control}
                name={kind}
                mode="onBlur"
              />
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  )
}

MainForm.propTypes = {
  editionPermitted: PropTypes.bool,
  isDPO: PropTypes.bool,
  editionMode: PropTypes.bool,
}

export default MainForm
